import { Method, cloudFunctionRequest } from '../cloudFunction'
import { asyncRequest, asyncSuccess, asyncFail, cleanMessages } from '../actions'

// action types

// action creators
export const fetchStats = (projectId, userToken) => {
  return dispatch => {
    dispatch(asyncRequest('fetchStats'))

    const postData = { userToken }

    cloudFunctionRequest(`project/${projectId}/statistics`, Method.POST, postData)
      .then(response => {
        dispatch(asyncSuccess('fetchStats', { stats: response.data.data }, null))
      })
      .catch(error => {
        dispatch(asyncFail('fetchStats'), error)
        dispatch(cleanMessages())
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/stats.js